<template>
   <el-dialog
   class="wrapper"
  :visible.sync="dialogVisible"
  :show-close="false"
  width="30%"
  title="请输入手机号保证您及时接收信息"
  :before-close="handleClose">
  <div class="input-wrap">
      <input type="text" v-model="mobile" placeholder="请输入手机号" class="user-input">
  </div>
  <div class="input-wrap has-code">
      <input type="text" v-model="code" placeholder="请输入验证码" class="user-input">
      <span class="send-code mouse-style" @click.stop="sendCode">{{showTimes ? `${times}秒后重新发送` : '发送验证码'}}</span>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" class="mouse-style" @click="confirm">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
import { jiashiSendCode } from '@/api/jiashi_web'
export default {
  data () {
    return {
      mobile: '',
      code: '',
      dialogVisible: false,
      times: 60,
      showTimes: false,
      timer: null,
      account: null // 计数器
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    confirm () {
      // this.dialogVisible = false
      // const reg = /^1[3|4|5|7|8][0-9]{9}$/
      if (!this.mobile) {
        this.$message({
          type: 'error',
          message: '请输入正确的电话号码'
        })
        return
      }
      this.$emit('confirm', this.mobile, this.code)
    },
    /* 发送验证码 */
    async sendCode () {
      // const reg = /^1[2-9][0-9]{9}$/
      if (!this.mobile) {
        this.$message({
          type: 'error',
          message: '请输入正确的电话号码'
        })
        return
      }
      if (this.timer) {
        return
      }
      // this.showTimes = true
      let res = await jiashiSendCode({ mobile: this.mobile, purpose: 'verilogin' })
      let temp = res.substring(5)
      temp = temp.replace(/\n/ig, '')
      res = JSON.parse(temp)
      if (res.data.toLowerCase() !== 'success' || !res.data) {
        this.showTimes = false
        this.code = ''
        this.timer = null
        this.$message({
          type: 'error',
          message: res.status.message
        })
        return
      } else {
        this.showTimes = true
      }
      // 开始倒计时
      this.account = setInterval(() => {
        this.times--
      }, 1000)
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        clearInterval(this.account)
        this.timer = null
        this.account = null
        this.showTimes = false
        this.times = 60
      }, 60000)
    },
    initData (special) {
      clearTimeout(this.timer)
      clearInterval(this.account)
      this.timer = null
      this.account = null
      this.showTimes = false
      this.times = 60
      if (!special) {
        this.mobile = ''
      }
      this.code = ''
    }
  }
}
</script>
<style scoped lang="scss">
.wrapper ::v-deep .el-dialog__header{
margin:0;
padding:0;
opacity: 1;
font-size: 18px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: left;
color: #333333;
line-height: 25px;
 padding:24px;
}
.wrapper ::v-deep .el-dialog__body{
 padding:24px 24px;
}
.wrapper ::v-deep .el-dialog__footer{
  padding:0 24px 24px 24px;
  text-align:center;
}
.input-wrap{
border-bottom:1px solid #eeeeee;
border-radius: 2px;
}
.user-input{
 border:none;
 outline: none;
 display:inline-block;
 width:100%;
 line-height:20px;
}
.user-input::placeholder{
  color:#CCCCCC;
}
.has-code {
  display:flex;
  padding-top:12px;
}
.has-code .user-input{
    flex:1;

}
.send-code{
 font-size: 14px;
font-weight: 400;
color: #187fc3;
line-height: 20px;
}
.wrapper ::v-deep .el-dialog__footer .el-button{
 padding:6px 24px;
 font-size:14px;
background: #187fc3;
border-radius: 4px;
}
</style>
